// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"e83d3fb0","167":"526ce673","189":"5fb900c4","315":"83f3d35a","628":"895c4943","638":"e52ee6f2","822":"fc9f124c","931":"9ed336fe","935":"5c20ffc1"}[chunkId] + ".chunk.js";
};